import React from 'react';

const GiftIcon = ({ size = '25px', className = '' }) => {
  return (
    <svg 
      viewBox="0 0 32 32"
      width={size}
      height={size}
      className={className}
      style={{ flex: 'none' }}
    >
      <path 
        fill="white"
        d="M16 4C12.686 4 10 6.686 10 10C10 10.552 10.448 11 11 11C11.552 11 12 10.552 12 10C12 7.791 13.791 6 16 6C18.209 6 20 7.791 20 10C20 10.552 20.448 11 21 11C21.552 11 22 10.552 22 10C22 6.686 19.314 4 16 4Z"
      />
      <path 
        fill="white"
        d="M8 12C7.448 12 7 12.448 7 13V15C7 15.552 7.448 16 8 16H24C24.552 16 25 15.552 25 15V13C25 12.448 24.552 12 24 12H8Z"
      />
      <path 
        fill="white"
        d="M7 18V26C7 27.105 7.895 28 9 28H23C24.105 28 25 27.105 25 26V18H7ZM12 22C11.448 22 11 22.448 11 23C11 23.552 11.448 24 12 24H20C20.552 24 21 23.552 21 23C21 22.448 20.552 22 20 22H12Z"
      />
      <path 
        fill="white"
        d="M16 8C15.448 8 15 8.448 15 9V11C15 11.552 15.448 12 16 12C16.552 12 17 11.552 17 11V9C17 8.448 16.552 8 16 8Z"
      />
    </svg>
  );
};

export default GiftIcon;
